export default function ProgramRoadmap() {
  const steps = [
    { icon: 'ri-search-eye-line', title: 'Диагностика', desc: 'Анализ текущих переписок, интервью с командой, определение болевых точек и зон роста.' },
    { icon: 'ri-file-search-line', title: 'Анализ переписок', desc: 'Глубокий разбор диалогов: Telegram, WhatsApp, CRM, e-mail. Выявление системных ошибок.' },
    { icon: 'ri-settings-line', title: 'Подготовка программы', desc: 'Адаптация под бизнес: продукт, цикл сделки, каналы коммуникации, уровень команды.' },
    { icon: 'ri-presentation-line', title: 'Практический тренинг', desc: '80% практики: разбор реальных переписок, ролевые упражнения, отработка скриптов.' },
    { icon: 'ri-task-line', title: 'Домашние задания', desc: 'Участники применяют техники в работе. Анализируем результаты на следующей сессии.' },
    { icon: 'ri-chat-check-line', title: 'Разбор новых переписок', desc: 'Анализируем свежие диалоги: что улучшилось, над чем ещё работать.' },
    { icon: 'ri-user-voice-line', title: 'Сопровождение', desc: 'Посттренинговая поддержка: чат, обратная связь, корректировка стратегии.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-flow-chart"></i>
            Структура программы
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Из чего состоит программа
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Системный подход: от глубокой диагностики до устойчивого результата. Каждый этап обязателен.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {steps.map((item, i) => (
              <div key={i} className="relative group">
                <div className="bg-white rounded-xl p-5 md:p-6 border border-gray-100 hover:border-teal-100 hover:bg-teal-50/30 transition-colors h-full">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                      <span className="text-white font-bold text-sm">{i + 1}</span>
                    </div>
                    <div className="w-8 h-8 bg-teal-600/10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-teal-600/15 transition-colors">
                      <i className={`${item.icon} text-teal-600 text-sm`}></i>
                    </div>
                  </div>
                  <h3 className="text-base font-semibold text-gray-900 mb-2">{item.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}